import React from 'react'
import './style.scss'
import { get } from 'lodash'
import VideoJSPlayer from '~/components/VideoPlayer'
import { getClosedCaptions, enableAutoplay, getSiblingEpisodes, getEpisodeIdx, fetchSeriesData, getSeasonIdx } from "./helpers";
import { getFilmSrc } from "~/modules/NewsShowPage/helpers";
import { displayCC } from "~/modules/NewsStandaloneVideoPlayer/helper";
import { muteLivePlayer } from "~/components/ExpandedDetails/helper";

class NewsEpisodeOverlay extends React.Component {
	state = {
		player: null,
		displayEpisodeSwitchOverlay: false,
		seasons: this.props.args.seasons || null
	}

	getVideoRef = (player) => {
		this.setState({player: player}, ()=>{
			displayCC(player, false);
			player.on("pause", () => {
				this.setState({displayEpisodeSwitchOverlay: true})
			})
			player.on("play", () => {
				this.setState({displayEpisodeSwitchOverlay: false})
			})
		});
	}

	async componentDidMount(){
		muteLivePlayer();
		let { video } = this.props.args;
		if(!this.props.args.seasons && video.series){
			const seasons = await fetchSeriesData(video.series);
			this.setState({ seasons })
		}
	}

	componentDidUpdate(prevProps, prevState){
		const { player } = this.state;
		if(player !== prevState.player){
			//Hide controlbar when video starts
			player.userActive(false);
		}
	}

	componentWillUnmount(){
		this.state.player && this.state.player.dispose();
	}

	render(){
		let { video, seasonIdx, episodeIdx } = this.props.args;
		const { displayEpisodeSwitchOverlay, seasons } = this.state;
		const videoId = (video.gist && video.gist.id) || video.id;
		if(!seasonIdx && seasons) seasonIdx = getSeasonIdx(seasons, videoId);
		const season = (seasons && seasonIdx >= 0) ? seasons[seasonIdx] : null;
		episodeIdx = episodeIdx !== undefined ? episodeIdx : getEpisodeIdx(season, videoId);
		const autoplayValue = enableAutoplay();
		const closedCaptions = getClosedCaptions(video);
		const { prevEp, nextEp, prevEpIdx, nextEpIdx} = getSiblingEpisodes(season, episodeIdx);
		const displayPauseOverlay = displayEpisodeSwitchOverlay && ( prevEp || nextEp );

		if(seasons) video.seasons = seasons;
		if(nextEpIdx >= 0 && season){
			video.nextEpisode = nextEp;
			video.playNextEpisode = (e) => {
				getFilmSrc(nextEp, season, seasonIdx, nextEpIdx);
				this.setState({displayEpisodeSwitchOverlay: false});
			}
		}
		
		return ( 
			<div className="news-overlay-player">
				<VideoJSPlayer
					{...this.props.args}
					video={{...video}}
					fileType={video.fileType}
					isEpisode={true}
					videoId={videoId}
					user={this.props.user}
					isFree={(video.gist && video.gist.free) || video.free}
					autoplay={autoplayValue}
					videoTag={get(window.settings, 'advertising.videoTag')}
					startTime={video.watchedTime}
					closedCaptions={closedCaptions}
					getVideoRef={this.getVideoRef.bind(this)}
				/>
				{ displayPauseOverlay && <div className="overlay-episode-switcher">
					{ prevEp && <div className="prev-episode">
						<div className="title">
							PREVIOUS
						</div>
						<div className="thumbnail" onClick={(e) => {
								getFilmSrc(prevEp, season, seasonIdx, prevEpIdx);
								this.setState({displayEpisodeSwitchOverlay: false});
							}}>
							<img src={`${prevEp.gist.videoImageUrl}?impolicy=resize&w=480&h=270`} alt="previous episode thumbnail" />
						</div>
					</div>}
					{ nextEp && <div className="next-episode">
						<div className="title">
							NEXT
						</div>
						<div className="thumbnail" onClick={(e) => {
								getFilmSrc(nextEp, season, seasonIdx, nextEpIdx);
								this.setState({displayEpisodeSwitchOverlay: false});
							}}>
							<img src={`${nextEp.gist.videoImageUrl}?impolicy=resize&w=480&h=270`} alt="next episode thumbnail" />
						</div>
					</div>}
				</div>}
			</div>
		)
	}
}

export default NewsEpisodeOverlay;